/*========================================================================
 * $Id: preview.js 73784 2013-07-16 10:25:30Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(["backbone", "underscore", "model/readonlytree", "service/stub", "service/factory", "utils/jsonpath", "i18n/i18n"],
function(Backbone, _, ReadOnlyTreeModel, Stub, ServiceFactory, JSONPath, i18n){

  var Common = {};

  var StatusMessages = Common.StatusMessages = {

    mergeMessage: function (lhs, rhs) {
      if (!rhs) return lhs;
      if (!lhs) return rhs;

      var merged = _.clone(lhs);
      if (!merged.service_ids) {
        merged.service_ids = [];
      }
      if (_.isArray(merged.service_ids) &&
          _.isArray(rhs.service_ids)) {
        merged.service_ids = merged.service_ids.concat(rhs.service_ids);
      }

      var props = ["error", "warning", "info"];
      _.each(props, function(prop) {
        if (!merged[prop] && rhs[prop]) {
          merged[prop] = rhs[prop];
        }
      });

      return merged;
    },

    parse: function(messages) {
      if (!messages) return messages;
      var result = {};
      _.each(messages, function(message) {
        var id = message.id;
        if (!id) return;
        result[id] = StatusMessages.mergeMessage(result[id], message);
      });
      return result;
    },

    merge: function(lhs, rhs) {
      // if we do not have any messages, we assume the empty list.
      if (!lhs) lhs = {};
      if (!rhs) rhs = {};
      var merged = _.clone(lhs);
      var keys = _.union(_.keys(merged), _.keys(rhs));
      _.each(keys, function(key) {
        if (key == "no_results" && (!merged[key] || !rhs[key])) {
          delete merged[key];
          return;
        }
        merged[key] = StatusMessages.mergeMessage(merged[key], rhs[key]);
      });
      return merged;
    }
  };


  var PropertyFormat = Common.PropertyFormat = {

       _selectProperty: function(values, selector) {

         var mapped  = _.map(values, selector);
         var results = [];
         for (var i = 0; i < mapped.length; ++i) {
           if (mapped[i] == null && values[i]) {
             continue;
           }
           results.push(mapped[i]);
         }
         if (results.length == 0 && values.length > 0) {
           return null;
         }
         // if (results.length == 1) return results[0];
         return results;
       },

       _getProperty: function(property, name, options) {
         // console.log("_getProperty", name, property);

         if (property != null && property.value == null && property.html == null && property.data == null
             && property.properties != null) {
           property = property.properties;
         }
         var propertyData = null;
         if (_.isArray(property)) {
           propertyData = _.reduce(property, function(result,p) {
             if (p && p.data) {
               if (_.isArray(p.data)) {
                 result = _.union(result, p.data);
               }
               else {
                 result.push(p.data);
               }
             }
             return result;
           }, []);
         }
         else {
           propertyData = property.data;
         }

         var isArray = _.isArray(propertyData);
         if (isArray) {
           var selected = PropertyFormat._selectProperty(propertyData, function(el) { if (el) return el[name]; else return undefined; });
           // console.log("_getProperty", selected);
           return selected;
         }
         else if (_.isObject(propertyData)) {
           return propertyData[name];
         }
         else if (_.isString(propertyData)) {
           return propertyData;
         }
         return null;
       },

       html: function(property, options) {
         if (!property) return null;
         // property: [ { data: [ { html: "one"}, {html: "two" } ] } ]
         // should return: ["one", "two" ]
         // case is that property is an array itself
         if (_.isArray(property)) {
           var html = PropertyFormat._selectProperty(property, function(p) { return PropertyFormat._getProperty(p, "html", options); });
           if (_.isArray(html)) {
             return _.flatten(html, false);
           }
           return html;
         }
         return PropertyFormat._getProperty(property, "html", options);

       },

       value: function(property, options) {
         if (!property) return null;
         if (_.isString(property)) return property;
         if (_.isArray(property)) {
           var value = PropertyFormat._selectProperty(property, function(p) {
              return PropertyFormat._getProperty(p, "value", options);
            });
           if (_.isArray(value)) {
             return _.flatten(value, false);
           }
           return value;
         }
         return PropertyFormat._getProperty(property, "value", options);

       },

       property: function(property, options) {
         if (!property) return undefined;

         // case of repeated properties
         if (_.isArray(property.data) && !property.properties) {
           var onlyProperties = true;
           var result = [];
           for (var i = 0; i < property.data.length && onlyProperties; ++i) {
             var obj = property.data[i];
             onlyProperties = obj.properties && !obj.html && !obj.value && !obj.data;
             result.push(obj.properties);
           }
           if (onlyProperties && result.length > 0) {
             return result;
           }
         }

         if (property.properties) return property.properties;
         if (_.isArray(property) && property.length &&
             _.reduce(property, function(memo,p) {
               if (p.id != null) {
                 memo--;
               }
               return memo;
             }, property.length) == 0) {
           var parent = {};
           Common.Properties.parse(parent, property);
           return parent;
         }
         return undefined; //property.properties;
       },

       forFormat: function(format, property, options) {
         if (_.isDate(property) || !_.isObject(property)) {
           return property;
         }
         switch(format) {
         case "HTML": return PropertyFormat.html(property, options);
         case "VALUE": return PropertyFormat.value(property, options);
         case "PROPERTY": return PropertyFormat.property(property, options);
         }
         throw new Error("Unsupported format", format, "!");
       }
   };

  var Properties = Common.Properties = {

      parseValue: function(value) {
        /*
          optional double num = 1;
          optional string unit   = 10;      // ms_since_1970

          optional string str = 3;

          // link properties
          // - e.g. actions as links
          optional string link_href = 5;
          optional string link_rel  = 6;

          optional QueryExpr query_expr = 7;
         */
        if (_.isString(value.str)) {
          return value.str;
        }

        if ( _.isNumber(value.num) && value.unit === undefined) {
          return value.num;
        }

        if (value.num && value.unit == "ms_since_1970") {
          return new Date(value.num);
        }

        if (value.query_expr) {
          return value.query_expr;
        }

        if (value.action) {
          return value.action;
        }

        return value;
    },

    minValue: function(lhs, rhs, orderCompareFunction) {
      return orderCompareFunction(lhs, rhs) < 0 ? lhs : rhs;
    },

    parseNested: function(properties, options) {

      return _.map(properties, function(property) {
        property = _.clone(property);
        if (_.isArray(property.data)) {
          var data = [];
          for (var i = 0; i < property.data.length; i++) {
            var datum = property.data[i];
            datum = _.clone(datum);
            datum["data:position"] = i;
            datum["property:id"] = property.id;
            if (datum.value) {
              datum.value = Common.Properties.parseValue(datum.value);
            }
            if (datum.html && datum.html.indexOf('data-name="entity"') > -1) {
              datum.html = Common.updateEntityPropLabel(datum.html, options);
            }
            var properties = {};
            Common.Properties.parse(properties, datum.properties);
            _.extend(datum, properties);
            data.push(datum);
          }
          property.data = data;
        }

        return property;
      });

    },


    parse: function(parent, properties, options) {
      /*
      properties: [{
      "name": "actions",
      "localized_name": ...
      "data": [
       {
        "html": "<a href=\"http://futurezone.at/b2b/3334-fabasoft-in-den-roten-zahlen.php\">Open</a>"
       },
       {
        "html": "<a href=\"tag:mindbreeze.com,2010/actions/preview/aHR0cHM6Ly9taW5kZW5ndm1sMDEubWluZGJyZWV6ZS5mYWJhZ2wuZmFiYXNvZnQuY29tOjIzMzAwOjIyNTYw\">Preview</a>"
       }
      ],
      "properties": [ { .. }]
      }]

       */
      if (!properties) return parent;
      var that = this;
      _.each(properties, function(property) {
        property = _.clone(property);

        if (_.isArray(property.data)) {
          property.data = _.map(property.data, function (datum) {
            if (datum.properties) {
              datum.properties = Common.Properties.parse({}, datum.properties);
            }

            if (!datum.value) {return datum; }
            datum = _.clone(datum);
            datum.value = Common.Properties.parseValue(datum.value);
            return datum;
          });
        }

        if (property.properties) {
          if (property.id === "icon" || property.id === "actions") {
            
            var propertyId = property.id;
            property.data = _.reduce(property.properties, function (data, property) {
              if (property.data) data = data.concat(property.data);

              // Set action id to the action object
              if (propertyId === "actions") {
                property.data = _.map(property.data, function(item) {
                  item.actionId = property.id;
                  return item;
                });
              }

              return data;
            }, []);
          } else {
            property.properties = Common.Properties.parseNested(property.properties, options);

            property.properties = _.filter(property.properties, function (property) {
              var hasData = _.find(property.data, function (data) {
                return data && (data.html || data.value);
              });
              return hasData;
            });
          }
        } else if (property.data) {
          for (var i = 0; i < property.data.length; i++) {
            var datum = property.data[i];
            if (datum.html && datum.html.indexOf('data-name="entity"') > -1) {
              datum.html = Common.updateEntityPropLabel(datum.html, options);
            }
          }
        }
        parent[property.id] = property;
      });

      return parent;
    },

    merge: function (lhs, rhs) {
      return Common.mapByPluck(Common.mergeByName(_.values(lhs), _.values(rhs), "id", function (lhs, rhs) {
        if (!lhs) return rhs;
        if (!rhs) return lhs;

        if (JSON.stringify(lhs) !== JSON.stringify(rhs)) {
          if (typeof console !== "undefined" && console.warn) console.warn("mismatch in facet value properties with id: '" + (lhs && lhs.id) + "'", lhs, rhs);
        }
        return lhs;
      }), "id");
    }

  };

  Common.isPropertyArray = function(property) {
    return (_.isArray(property) && property.length &&
            _.reduce(property, function(memo,p) {
              if (p && p.id != null) {
                memo--;
              }
              return memo;
            }, property.length) == 0);
  }

  Common.propertyListToArray = function (properties, keyProperty) {
    if (!properties || _.isArray(properties)) return properties;

    keyProperty = keyProperty || "id";

    var result = [];
    _.each(_.keys(properties), function(key) {
        var prop = properties[key];
        if (prop) {
          var resultProp = _.clone(prop);
          resultProp[keyProperty] = key;
          result.push(resultProp);
        }
    });

    if (result.length < 1) return undefined;

    return result;
  };

  Common.arrayToPropertyList = function (properties, keyProperty) {
    if (!properties || !_.isArray(properties)) return properties;

    keyProperty = keyProperty || "id";

    var result = {}
    for (var i = 0; i < properties.length; ++i) {
      if (properties[i][keyProperty]) {
        var key = properties[i][keyProperty];
        result[key] = properties[i];
      }
      else {
        result = properties;
        break;
      }
    }

    return result;
  };

  Common.mapByPluck = function (list, name) {
    var map = {};

    _.each(list, function (entry) {
        if (!entry) return;

        var key = entry[name];
        if (key) {
          map[key] = entry;
        }
    });

    return map;
  }
  
  Common.mergeByName = function (lhs, rhs, name, mergeFunction) {
     if (!lhs) return rhs;
     if (!rhs) return lhs;

     var lhsByName = Common.mapByPluck(lhs, name),
         rhsByName = Common.mapByPluck(rhs, name),
         names = _.union(_.keys(lhsByName), _.keys(rhsByName)).sort();

     return _.map(names, function (name) {
       var l = lhsByName[name],
           r = rhsByName[name];

       return mergeFunction ? mergeFunction(l, r) : l || r;
     });
   },

  Common.genericCompare = function(lhs, rhs, options) {
    if (_.isObject(lhs) && _.isObject(rhs)) {
      lhs = JSON.stringify(lhs);
      rhs = JSON.stringify(rhs);
    }
    if (_.isString(lhs) && _.isString(rhs)) {
      lhs = lhs.toLowerCase();
      rhs = rhs.toLowerCase();
      if (lhs > rhs)
        return 1;
      else if (lhs < rhs)
        return -1;
      // fall through that we have a defined ordering on case
    }
    if (lhs > rhs) return 1; else if (lhs < rhs) return -1; return 0;
  }

  Common.valueCompare = function (lhsValue, rhsValue) {
    if (lhsValue && lhsValue.num && rhsValue && rhsValue.num) {
      return Common.genericCompare(lhsValue.num, rhsValue.num);
    }
    if (lhsValue && lhsValue.str && rhsValue && rhsValue.str) {
      return Common.genericCompare(lhsValue.str, rhsValue.str);
    }
    if (_.isArray(lhsValue) && _.isArray(rhsValue)) {
      return Common.valueCompare(
        _.first(lhsValue.sort(Common.valueCompare)),
        _.first(rhsValue.sort(Common.valueCompare))
      );
    }
    return Common.genericCompare(lhsValue, rhsValue);
  }

  Common.PROPERTY_COMPARE_FUNCTION = function (propertyPath, options) {
    var jsonPath = JSONPath.parsePath(propertyPath);

    function get(obj, path) {
      if (obj && obj.get && _.isFunction(obj.get)) {
        return obj.get(path, { outputOnly: true });
      }
      return JSONPath.get(obj, path);
    }

    return function(lhs, rhs) {
      var lhsValue = lhs && get(lhs, jsonPath),
          rhsValue = rhs && get(rhs, jsonPath);

      if (options && _.isFunction(options.valueCompare)) {
        return options.valueCompare(lhsValue, rhsValue);
      }
      return Common.valueCompare(lhsValue, rhsValue);
    }
  }
  Common.PREDEFINED_ORDER_COMPARE_FUNCTION = function (propertyPath, orderedList, options) {
    var jsonPath = JSONPath.parsePath(propertyPath);
    orderedList = orderedList || [];

    function get(obj, path) {
      if (obj && obj.get && _.isFunction(obj.get)) {
        return obj.get(path);
      }
      return JSONPath.get(obj, path);
    }

    return function(lhs, rhs) {
      var lhsValue = lhs && get(lhs, jsonPath),
          rhsValue = rhs && get(rhs, jsonPath);

      var lhsIndex = orderedList.indexOf(lhsValue),
          rhsIndex = orderedList.indexOf(rhsValue);

      if (lhsIndex < 0) lhsIndex = Number.MAX_VALUE;
      if (rhsIndex < 0) rhsIndex = Number.MAX_VALUE;

      if (lhsIndex == rhsIndex) {
        if (options && _.isFunction(options.valueCompare)) {
          return options.valueCompare(lhsValue, rhsValue);
        }
        return Common.valueCompare(lhsValue, rhsValue);
      }
      return lhsIndex < rhsIndex ? -1 : 1;
    }
  }

  var ONE_DAY_MS = 24*3600*1000 ;

  Common.valueCompareYear = function(v1, v2) {
    if (v1 && v2 && v1.unit == "ms_since_1970" && v1.unit == v2.unit ) {
      v1 = new Date(v1.num + ONE_DAY_MS);
      v2 = new Date(v2.num + ONE_DAY_MS);
    }
    if (_.isDate(v1) && _.isDate(v2)) {
      return v1.getFullYear() - v2.getFullYear();
    }
    else {
      return Common.valueCompare(v1, v2);
    }
  }
  Common.valueCompareMonth = function(v1, v2) {
    if (v1 && v2 && v1.unit == "ms_since_1970" && v1.unit == v2.unit ) {
      v1 = new Date(v1.num + ONE_DAY_MS);
      v2 = new Date(v2.num + ONE_DAY_MS);
    }
    if (_.isDate(v1) && _.isDate(v2)) {
      return v1.getMonth() - v2.getMonth();
    }
    else {
      return Common.valueCompare(v1, v2);
    }
  }


  Common.COMPARE_BY_CRITERIA = {

    "PREDEFINED": Common.PREDEFINED_ORDER_COMPARE_FUNCTION,
    "PROPERTY": Common.PROPERTY_COMPARE_FUNCTION,
    "ORDER": Common.PROPERTY_COMPARE_FUNCTION("order"),
    "VALUE": Common.PROPERTY_COMPARE_FUNCTION("value"),
    "YEAR": Common.PROPERTY_COMPARE_FUNCTION("query_expr.value", {valueCompare: Common.valueCompareYear }),
    "MONTH": Common.PROPERTY_COMPARE_FUNCTION("query_expr.value", {valueCompare: Common.valueCompareMonth }),
    "HTML": function(lhs, rhs)  {
      return Common.genericCompare(lhs.count, rhs.count);
    },
    "COUNT": function (lhs, rhs) {
      return Common.PROPERTY_COMPARE_FUNCTION("count", {
        valueCompare: function (l, r) {
          return (l || -1) - (r || -1);
        }
      })(lhs, rhs);
    },
    "ORDER_COUNT": function (lhs, rhs) {
      return Common.PROPERTY_COMPARE_FUNCTION("order_count", {
        valueCompare: function (l, r) {
          return (l || -1) - (r || -1);
        }
      })(lhs, rhs);
    }
  }

  Common.getCompareFunction = function (criteria, direction, options) {
    options = options || {};

    if (direction !== "DESCENDING") {
      direction = "ASCENDING";
    }

    var sortFunction = Common.COMPARE_BY_CRITERIA[criteria] || Common.COMPARE_BY_CRITERIA["ORDER"];

    if (criteria === "PROPERTY") {
      // use generator function
      sortFunction = sortFunction(options.criteriaPropertyName);
    }
    else if (criteria == "PREDEFINED") {
      sortFunction = sortFunction(options.criteriaPropertyName || "value", options.predefinedOrder);
    }
    sortFunction = Common.ORDER_TRANSFORMER[direction](sortFunction);

    if (options.subCriteria) {
      sortFunction = Common.SUBCRITERIA_TRANSFORMER(sortFunction, Common.getCompareFunction(options.subCriteria.criteria, options.subCriteria.direction, options.subCriteria.options));
    }

    return sortFunction;
  }

  Common.getValues = function (list, propertyPath) {
    var values = [];
    _.forEach(list, function (entry) {
      values = values.concat(JSONPath.get(entry, propertyPath));
    });
    return _.uniq(values);
  }

  Common._distributeGroupWeights = function (allWeights, groupedEntries, baseWeight) {
    // adapt weights based on group size
    var sortedWeightKeys = _.keys(allWeights).sort(function (a, b) {
      return allWeights[a] - allWeights[b];
    });

    var accumulatedWeight = baseWeight || 0;
    _.forEach(sortedWeightKeys, function (weightKey, index) {
      var entries = groupedEntries[weightKey],
          offset = (entries && entries.length) || 0;

      allWeights[weightKey] = accumulatedWeight;
      accumulatedWeight += offset;
    });

    return allWeights;
  };

  Common._getMinValue = function (value, allWeights) {
    var minValue;

    if (_.isArray(value)) {
      if (value.length === 1) {
        return value[0];
      }

      minValue = _.min(value, function (value) { return allWeights[value]; });
      if (minValue === Infinity) {
        return value.join(",");
      } else {
        return minValue;
      }
    }
    return value;
  }

  Common.wrapOrderFunctionWithSort = function (orderFunction, sortFunction) {
    return function (list, originalSortFunction) {
      return orderFunction.apply(this, [list, sortFunction].concat(Array.prototype.slice.call(arguments, 2)));
    }
  }

  Common.getOrderFunctionByList = function (order, propertyPath, subOrderFunction, options) {
    order = order || [];
    options = options || {};

    var weights = _.object(order, _.range(order.length)),
        nextAvailableWeight = order.length;

    propertyPath = JSONPath.parsePath(propertyPath || "name");

    return function (list, originalSortFunction, baseWeight) {
      var group = _.uniqueId("group");
      var allWeights = _.clone(weights),
          values = Common.getValues(list, propertyPath),
          unweightedValues = _.reduce(values, function (unweightedValues, value) {
            var weight = allWeights[value];
            if (typeof weight === "undefined") {
              unweightedValues.push(value);
            }
            return unweightedValues;
          }, []),
          groupedEntries;

      if (unweightedValues.length > 0) {
        if (!options.applyPartial && _.isFunction(originalSortFunction)) {
          // sort the list according to the original order
          list.sort(originalSortFunction);
        }

        _.forEach(list, function (entry, index) {
          var value = JSONPath.get(entry, propertyPath),
              weight;

          value = Common._getMinValue(value, allWeights);
          if (options.applyPartial && typeof weights[value] === "undefined") {
            value = "Mindbreeze.unweighted";
          }
          if (typeof allWeights[value] === "undefined") {
            weight = nextAvailableWeight;
            if (!options.applyPartial) {
              weight += index;
            }
            allWeights[value] = weight;
          }
        });
      }

      groupedEntries = _.groupBy(list, function (entry) {
        var value = JSONPath.get(entry, propertyPath);
        value = Common._getMinValue(value, allWeights);

        if (options.applyPartial && typeof weights[value] === "undefined") {
          value = "Mindbreeze.unweighted";
        }

        return value;
      });

      allWeights = Common._distributeGroupWeights(allWeights, groupedEntries, baseWeight);

      _.forEach(groupedEntries, function (entries, key) {
        var weight = allWeights[key];
        if (entries.length > 1) {
          if (subOrderFunction) {
            subOrderFunction(entries, options.applyPartial ? originalSortFunction : originalSortFunction.subSortFunction, weight);
          } else {
            _.forEach(entries, function (entry, index) {
              entry.order = { num: weight + index };
            });
          }
        } else {
          entries[0].order = { num: weight };
        }
      });
    }
  }

  Common.sortByCriteria = function (listOrMap, options) {
    if (!listOrMap) return;

    var isMap = !_.isArray(listOrMap),
        list = listOrMap,
        sortFunction = options.sortFunction || Common.getCompareFunction(options.criteria, options.direction, options);

    if (isMap) {
      list = _.values(listOrMap);
    }

    if (options.applyCustomOrder) {
      options.applyCustomOrder(list, sortFunction);
      sortFunction = options.sortFunction || Common.getCompareFunction("ORDER", "ASCENDING", options);
    }

    list = list.sort(sortFunction);

    if (isMap) {
      return Common.mapByPluck(list, options.mapKeyPropertyName);
    }
    return list;
  }

  Common.ORDER_TRANSFORMER = {
    "DESCENDING": function(compareFunction) { return function() { return - compareFunction.apply(this, arguments); } },
    "ASCENDING" : function(compareFunction) { return compareFunction; }
  };

  Common.SUBCRITERIA_TRANSFORMER = function(compareFunction, subCriteriaFunction) {
    var f = function() {
      var value = compareFunction.apply(this, arguments);
      if (value === 0) {
        return subCriteriaFunction.apply(this, arguments);
      }
      return value;
    }
    f.subSortFunction = subCriteriaFunction;

    return f;
  };

  Common.mergePropertyDefinitions = function (properties1, properties2) {
    if (!properties1) return properties2;
    _.each(properties2, function (value, name) {
        var oldValue = properties1[name];
        if (oldValue && oldValue.format !== value.format) {
          value.format = "PROPERTY";
        }
        properties1[name] = value;
    });
    return properties1;
  };

  Common.hasMoreResults = function (per_service_dataset) {
    return _.reduce(per_service_dataset, function (hasMoreResults, service_dataset) {
      return hasMoreResults || (service_dataset && service_dataset.termination_cause === "COUNT_LIMIT");
    }, false);
  };

  Common.prepareEntityHTML = function (html, options) {
    var themeOptions = options
                       && options.channel
                       && options.channel.options.application
                       && options.channel.options.application.options.theme;

    return html.replace(/data-prop-label=\"(.*?)\"/g, function (group, entityLabel) {
      // Internationalize label
      var finalHTML = 'data-prop-label="' + entityLabel + '" data-prop-label-translated="' + i18n('entity_' + entityLabel) + '" ';
      
      // Apply custom theme styles if provided in application properties
      if (themeOptions) {
        var entitiesThemeOptions = Common.getThemeOptionsbyPath('elements.entities', themeOptions);
        if (entitiesThemeOptions && entitiesThemeOptions[entityLabel]) {
          var entityStyles = Common.getEntityStyle(entitiesThemeOptions[entityLabel]);
          var entityTooltipStyles = Common.getEntityStyle(entitiesThemeOptions[entityLabel].tooltip || {});

          if (entityStyles) finalHTML = finalHTML +  ' style="' + entityStyles + '"';

          if (entityTooltipStyles) finalHTML = finalHTML +  ' data-tooltip-style="' + entityTooltipStyles + '"';
        }
      }

      return finalHTML;
    });
  };

  Common.getEntityStyle = function (theme) {
    var style = '';
    theme = _.clone(theme);
    delete theme.tooltip;
    _.each(theme, function(cssValue, cssKey) {
      style += cssKey + ':' + cssValue + ';';
    });
    return style;
  }

  Common.updateEntityPropLabel = function (html, options) {
    var html = Common.prepareEntityHTML(html, options);
    return html;
  };

  Common.getThemeOptionsbyPath = function (path, themeOptions) {
    if (!path || !themeOptions) {
      return;
    }
    return _.reduce(path.split('.'), function(memo, key) {
      return memo && memo[key];
    }, themeOptions);
  };

  Common.simplifyQueryExpr = function(queryExpr) {
    if (!queryExpr) {
      return queryExpr;
    }

    if (!_.isObject(queryExpr)) {
      return queryExpr;
    }
    // handle and, or for now
    var obj = queryExpr.and || queryExpr.or;
    if (!obj) {
      return queryExpr;
    }

    var elts = _.isArray(obj) ? _.range(0, obj.length) : _.keys(obj);

    if (elts.length == 1) {
      return Common.simplifyQueryExpr(obj[elts[0]]);
    }

    for (var key in elts) {
      obj[key] = Common.simplifyQueryExpr(obj[key]);
    }
    return queryExpr;
  };


  Common.removeQueryExprByID = function(query, id) {
    // 1. simplify
    query = Common.simplifyQueryExpr(query);
    if (query && _.isObject(query) && query.id == id) {
      return null;
    }

        
    var paths = JSONPath.getMatchingPaths(query, function(obj) { return _.isObject(obj) && obj.id == id; })
    _.each(paths, function(path) {
      JSONPath.unset(query, path);
    });
    // 2. simplify
    if (paths && paths.length > 0) {
      query = Common.simplifyQueryExpr(query);
    }
    return query;
  };
  
  return Common;
 });
